import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout.js"
import RestaurantDetails from "../components/restaurantDetails"
import MenuDetails from "../components/menuDetails"
import SEO from "../components/seo"
import Image from "gatsby-image"
import { getMenu } from "../utils/getMenus"

export const query = graphql`
  query($id: ID!) {
    wpgraphql {
      restaurantMetadata(id: $id) {
        allCitiessMetadata {
          nodes {
            name
            slug
          }
        }
        allFoodTypessMetadata {
          nodes {
            name
            slug
          }
        }
        restaurantACF {
          address
          available
          isMenuUpdatedDaily
          ongoinMenus {
            date
            dateDeDebut
            dateDeFin
            desserts
            plats
            remarques
            starters
          }
          opening {
            dimanche
            jeudi
            lundi
            mardi
            mercredi
            samedi
            vendredi
          }
          optionPlatSeul
          pageFacebook
          phone
          siteWeb
          tarifs {
            tarifEntreePlatDessert
            tarifEntreePlatOuPlatDessert
            tarifPlatSeul
          }
          typeDeMenu
        }
        content(format: RENDERED)
        featuredImage {
          node {
            title(format: RENDERED)
            sourceUrl
            imageFile {
              childImageSharp {
                fluid(maxWidth: 1140, maxHeight: 500) {
                  ...GatsbyImageSharpFluid
                }
                resize(width: 900, quality: 90) {
                  src
                }
              }
            }
          }
        }
        title(format: RENDERED)
        id
        slug
      }
    }
  }
`
const RestaurantTemplate = ({ data }) => {
  const restaurant = data.wpgraphql.restaurantMetadata
  const featuredImage = restaurant.featuredImage
    ? restaurant.featuredImage.node
    : null
  const metaFeatured = featuredImage
    ? featuredImage.imageFile.childImageSharp.resize.src
    : null
  const details = getMenu(restaurant.restaurantACF)

  return (
    <Layout>
      <SEO
        title={`Mes plats du jour | Formules et plats du jour du restaurant : ${restaurant.title}`}
        metaFeatured={metaFeatured}
      />
      <div className="grid-container">
        <section className="section">
          <div className="flex-container mb-2">
            <Image
              fluid={
                restaurant.featuredImage.node.imageFile.childImageSharp.fluid
              }
              objectFit="cover"
              objectPosition="50% 50%"
              alt={featuredImage.title}
            />
          </div>
          <h1 className="text-center">
            Mes plats du jour | Formules et plats du jour du restaurant :{" "}
            {restaurant.title}
          </h1>
        </section>
        <section className="mb-2">
          <div className="grid-x grid-margin-x align-stretch mb-2 flex-dir-column-reverse large-flex-dir-row">
            <div className="cell small-12 large-8">
              <RestaurantDetails details={restaurant} />
            </div>
            <div className="cell small-12 large-4">
              <MenuDetails title={restaurant.title} details={details} />
            </div>
          </div>
        </section>
      </div>
    </Layout>
  )
}

export default RestaurantTemplate
